import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers } from "vue"

const _hoisted_1 = { class: "comment_footer" }
const _hoisted_2 = { class: "textfield_container extrainfoDv attachment" }
const _hoisted_3 = { class: "d-flex align-items-end w-100 firstDv" }
const _hoisted_4 = ["data-placeholder"]
const _hoisted_5 = {
  key: 0,
  class: "suggestions bottom"
}
const _hoisted_6 = {
  key: 1,
  class: "suggestions bottom"
}
const _hoisted_7 = {
  key: 2,
  class: "loader"
}
const _hoisted_8 = { class: "comment_footer_icon emoji_icon" }
const _hoisted_9 = { class: "emoji_picker_container" }
const _hoisted_10 = { class: "comment_footer_icon send_icon" }
const _hoisted_11 = {
  key: 0,
  class: "media_card"
}
const _hoisted_12 = ["onClick"]
const _hoisted_13 = ["src"]
const _hoisted_14 = ["src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_IconComponent = _resolveComponent("IconComponent")!
  const _component_ProfileAvatarComponent = _resolveComponent("ProfileAvatarComponent")!
  const _component_StockAutocompleteComponent = _resolveComponent("StockAutocompleteComponent")!
  const _component_ProfileAutocompleteComponent = _resolveComponent("ProfileAutocompleteComponent")!
  const _component_VuemojiPicker = _resolveComponent("VuemojiPicker")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        class: "comment_footer_icon",
        onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.uploadFile()))
      }, [
        _createElementVNode("input", {
          class: _normalizeClass(['commentUploader' + _ctx.sourceId, "d-none"]),
          onChange: _cache[0] || (_cache[0] = ($event: any) => (_ctx.uploadMedia($event))),
          type: "file",
          name: "file",
          id: "uploadImage",
          ref: "file"
        }, null, 34),
        _createVNode(_component_IconComponent, {
          path: "",
          className: "",
          icon: "Camera.svg"
        })
      ])
    ]),
    _createElementVNode("div", {
      class: _normalizeClass(["textfield_container extrainfoDv textfield", { limitExceeded: _ctx.isLimitExceeded }])
    }, [
      _createElementVNode("div", _hoisted_3, [
        (_ctx.isComment)
          ? (_openBlock(), _createBlock(_component_ProfileAvatarComponent, {
              key: 0,
              badges: false,
              border: true,
              class: "small mr-10 c-pointer",
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.goToProfile(_ctx.user))),
              profileImage: _ctx.profilePicture
            }, null, 8, ["profileImage"]))
          : _createCommentVNode("", true),
        _createElementVNode("div", {
          class: _normalizeClass(["textarea", 'commentTextField' + _ctx.sourceId]),
          onInput: _cache[3] || (_cache[3] = ($event: any) => (_ctx.debounce($event))),
          onPaste: _cache[4] || (_cache[4] = ($event: any) => (_ctx.onPaste($event))),
          onKeyup: _cache[5] || (_cache[5] = ($event: any) => (_ctx.onBackspacePressed($event))),
          onKeypress: _cache[6] || (_cache[6] = _withKeys(($event: any) => (_ctx.onEnterPressed($event)), ["enter"])),
          contenteditable: "",
          "data-placeholder": _ctx.placehorderText
        }, null, 42, _hoisted_4),
        (_ctx.comment.suggestions.list && _ctx.comment.suggestions.list.length)
          ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
              (_ctx.comment.suggestions.symbol == '$')
                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comment.suggestions.list, (stock) => {
                      return (_openBlock(), _createBlock(_component_StockAutocompleteComponent, {
                        key: stock,
                        onClick: ($event: any) => (_ctx.addStockToComment(stock)),
                        stock: stock
                      }, null, 8, ["onClick", "stock"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true),
              (_ctx.comment.suggestions.symbol == '@')
                ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comment.suggestions.list, (user) => {
                      return (_openBlock(), _createBlock(_component_ProfileAutocompleteComponent, {
                        key: user._id,
                        onClick: ($event: any) => (_ctx.addUserToComment(user)),
                        user: user
                      }, null, 8, ["onClick", "user"]))
                    }), 128))
                  ]))
                : _createCommentVNode("", true)
            ], 64))
          : _createCommentVNode("", true),
        (_ctx.isLoading)
          ? (_openBlock(), _createElementBlock("div", _hoisted_7))
          : (_openBlock(), _createElementBlock(_Fragment, { key: 3 }, [
              _createElementVNode("a", _hoisted_8, [
                _createVNode(_component_IconComponent, {
                  path: "",
                  onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => (_ctx.toggleEmojiPicker()), ["stop"])),
                  className: "createpost_footer_icon",
                  icon: "Post_Smiley.svg"
                }),
                _createElementVNode("div", _hoisted_9, [
                  (_ctx.isEmojiPickerShown)
                    ? (_openBlock(), _createElementBlock("div", {
                        key: 0,
                        class: "emoji_backdrop",
                        onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => (_ctx.toggleEmojiPicker(false)), ["stop"]))
                      }))
                    : _createCommentVNode("", true),
                  (_ctx.isEmojiPickerShown)
                    ? (_openBlock(), _createBlock(_component_VuemojiPicker, {
                        key: 1,
                        class: "emojiPicker",
                        onEmojiClick: _ctx.selectEmoji,
                        numColumns: "auto",
                        emojiSize: "14px",
                        emojiPadding: "0",
                        width: "100%",
                        isDark: true,
                        background: "#201e29"
                      }, null, 8, ["onEmojiClick"]))
                    : _createCommentVNode("", true)
                ])
              ]),
              _createElementVNode("a", _hoisted_10, [
                _createVNode(_component_IconComponent, {
                  path: "",
                  onClick: _cache[9] || (_cache[9] = _withModifiers(($event: any) => (_ctx.onEnterPressed($event, true)), ["stop"])),
                  className: "createpost_footer_icon",
                  icon: "Send_Icon.svg"
                })
              ])
            ], 64))
      ]),
      (_ctx.comment.media && _ctx.comment.media.length)
        ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.comment.media, (media, index) => {
              return (_openBlock(), _createElementBlock(_Fragment, { key: index }, [
                _createElementVNode("i", {
                  onClick: ($event: any) => (_ctx.removeMedia(index)),
                  class: "fas fa-times-circle icon_cross clickable"
                }, null, 8, _hoisted_12),
                (!media.type.includes('video'))
                  ? (_openBlock(), _createElementBlock("img", {
                      key: 0,
                      src: media.url
                    }, null, 8, _hoisted_13))
                  : (_openBlock(), _createElementBlock("video", {
                      key: 1,
                      controls: "",
                      style: {"height":"100%","width":"100%"},
                      src: media.url
                    }, null, 8, _hoisted_14))
              ], 64))
            }), 128))
          ]))
        : _createCommentVNode("", true)
    ], 2)
  ]))
}